import Swal from 'sweetalert2';
import Rails from '@rails/ujs';

const MF_API_URL = 'https://wl-api.mf.gov.pl';

let lookupInProgress = false;

const todayLocalDate = () => {
  const today = new Date();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');

  return `${today.getFullYear()}-${month}-${day}`;
};

const submitForm = () => {
  $('.x-form-data.settings-content.x-submit').submit();
};

const confirmSaveWhenCannotVerify = () => {
  Swal.fire({
    html:
      '<div>Nie możemy zweryfikować numeru konta na białej liście podatników VAT.<br/>' +
      'Czy mimo to chcesz zapisać numer rachunku?</div>',
    title: 'Potwierdź dane',
    showCloseButton: true,
    showCancelButton: true,
    confirmButtonText: 'Zapisz',
    confirmButtonColor: '#1E88E5',
    cancelButtonText: 'Anuluj',
    cancelButtonColor: '#F3F2FD',
    customClass: {
      container: 'notification-modal',
    },
  }).then((result) => {
    if (result.isConfirmed) {
      submitForm();
    }
  });
};

const isActiveVatPayer = ({ nip }) =>
  fetch(`${MF_API_URL}/api/search/nip/${nip}?date=${todayLocalDate()}`)
    .then((res) => res.json())
    .then((data) => data.result?.subject?.statusVat === 'Czynny')
    .catch(() => null);

const sendWhitelistEvent = ({ source, userUuid, onWhitelist }) => {
  if (source !== 'settings' || typeof window.userengage !== 'function') return;

  window.userengage('event.bank_account_whitelist_checked', {
    source,
    user_uuid: userUuid,
    on_whitelist: onWhitelist,
    timestamp: Date.now(),
  });
};

const getWhiteList = ({ nip, ibanValueNumber, source, userUuid }) =>
  fetch(`${MF_API_URL}/api/check/nip/${nip}/bank-account/${ibanValueNumber}?date=${todayLocalDate()}`)
    .then((res) => res.json())
    .then((data) => {
      if (data.message) {
        confirmSaveWhenCannotVerify();
        return;
      }
      const template =
        '<div>Podany numer rachunku nie znajduje się na białej liście podatników VAT<br /> ' +
        'powiązanej z numerem NIP Twojej firmy.<br /> Czy mimo to chcesz zapisać numer rachunku?</div>';
      const containerClass = document
        .querySelector('button[data-check-whitelist]')
        .getAttribute('data-container-class');
      if (data.result) {
        if (data.result.accountAssigned === 'NIE') {
          Swal.fire({
            html: template,
            title: 'Potwierdź dane',
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: 'Zapisz',
            confirmButtonColor: '#1E88E5',
            cancelButtonText: 'Anuluj',
            cancelButtonColor: '#F3F2FD',
            customClass: {
              container: containerClass,
            },
          }).then((result) => {
            if (result.isConfirmed) {
              sendWhitelistEvent({ source, userUuid, onWhitelist: false });
              submitForm();
            }
            $('#form_data_numer_konta').parent('.row').removeClass('alert--error');
          });
        } else {
          sendWhitelistEvent({ source, userUuid, onWhitelist: true });
          submitForm();
        }
      }
    })
    .catch(() => {
      confirmSaveWhenCannotVerify();
    });

function handleConfirm() {
  const { whitelistSource: source, userUuid } = this.dataset;
  const nipValue = document.querySelector('#form_data_user_nip').value;
  const ibanValue = document.querySelector('#form_data_numer_konta').value.replace(/\s/g, '');

  if (nipValue && ibanValue) {
    if (lookupInProgress) return false;
    lookupInProgress = true;

    const ibanValueNumber = ibanValue.startsWith('PL') ? ibanValue.replace('PL', '') : ibanValue;

    isActiveVatPayer({ nip: nipValue })
      .then((activeVatPayer) => {
        if (activeVatPayer) {
          return getWhiteList({ nip: nipValue, ibanValueNumber, source, userUuid });
        }
        if (activeVatPayer === false) {
          submitForm();
        } else {
          confirmSaveWhenCannotVerify();
        }
        return undefined;
      })
      .finally(() => {
        lookupInProgress = false;
      });
    return false;
  }
  if (ibanValue && !nipValue) {
    confirmSaveWhenCannotVerify();
    return false;
  }
  return true;
}

Rails.delegate(document, 'button[data-check-whitelist]', 'click', handleConfirm);
